import { call, put, select } from 'redux-saga/effects';

import * as actions from './company-tools-categories.actions';
import * as companyToolsCategoryResourceService from '../../../resource/company-tools-category/company-tools-category.saga-service';
import * as dialogService from '../../../dialog/dialog.saga-services';
import { companyToolsCategoriesPageSelectors } from './company-tools-categories.selectors';
import {
  ICompanyToolsCategory,
  ICompanyToolsCategoryCreateForm,
} from '../../../resource/company-tools-category/company-tools-category.types';
import { clearFormAvatar, saveCropCounter } from '../users/user-form/user-form.actions';
import { formSelectors } from '../users/user-form/user-form.selectors';

export function* clearCompanyToolsCategories() {
  yield put(actions.clearCompanyToolsCategories());
}

export function* setupCompanyToolsCategories() {
  const companyToolsCategories = (yield call(
    companyToolsCategoryResourceService.searchCompanyToolsCategories,
  )) as ICompanyToolsCategory['id'][];

  yield put(
    companyToolsCategories
      ? actions.storeCompanyToolsCategories(companyToolsCategories)
      : actions.clearCompanyToolsCategories(),
  );
}

export function* clearCompanyToolsCategoriesPageStorage() {
  yield put(actions.clearCompanyToolsCategories());
}

export function* createCompanyToolsCategory(form: ICompanyToolsCategoryCreateForm) {
  const imageData = (yield select(formSelectors.selectFormAvatar)) as string;

  const companyToolsCategory = (yield call(companyToolsCategoryResourceService.createCompanyToolsCategory, {
    ...form,
    avatar: imageData || null,
  })) as ICompanyToolsCategory | undefined;

  if (!companyToolsCategory) {
    return;
  }

  const ids = (yield select(
    companyToolsCategoriesPageSelectors.selectCompanyToolsCategories,
  )) as ICompanyToolsCategory['id'][];
  yield put(actions.storeCompanyToolsCategories([...ids, companyToolsCategory.id]));
  yield put(clearFormAvatar());
  yield put(saveCropCounter(0));
  yield call(dialogService.closeDialog, 'companyToolsCategoryFormDialog');
}

export function* updateCompanyToolsCategory(
  companyToolsCategoryId: ICompanyToolsCategory['id'],
  form: ICompanyToolsCategoryCreateForm,
) {
  const imageData = (yield select(formSelectors.selectFormAvatar)) as string;
  const cropCounter = (yield select(formSelectors.selectCropCounter)) as number;

  const companyToolsCategory = (yield call(companyToolsCategoryResourceService.updateCompanyToolsCategory, {
    id: companyToolsCategoryId,
    ...form,
    ...(cropCounter > 1 ? { avatar: imageData || null } : {}),
  })) as ICompanyToolsCategory | undefined;

  if (!companyToolsCategory) {
    return;
  }

  yield put(clearFormAvatar());
  yield put(saveCropCounter(0));
  yield call(dialogService.closeDialog, 'companyToolsCategoryFormDialog');
}

export function* deleteCompanyToolsCategory(companyToolsCategoryId: ICompanyToolsCategory['id']) {
  const deleted = (yield call(
    companyToolsCategoryResourceService.deleteCompanyToolsCategory,
    companyToolsCategoryId,
  )) as boolean;

  if (!deleted) {
    return;
  }

  const ids = (yield select(
    companyToolsCategoriesPageSelectors.selectCompanyToolsCategories,
  )) as ICompanyToolsCategory['id'][];
  yield put(actions.storeCompanyToolsCategories(ids.filter((id) => id !== companyToolsCategoryId)));
}
